<template>
  <div ref="chartContainer" :style="this.chartStyle ? this.chartStyle : { width: '100%', height: '180px' }" />
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';

export default {
  name: 'BarsChart',
  props:{
    chartData:Object,
    chartStyle: Object
  },
  methods: {
    createChart(dataSeries, options) {
      let defaultOptions = {
        series: {
          bars: {
            barWidth:2,
            show: true,
            align: "center",
            fillColor: {
              colors: [{
                opacity: 1,
              }, {
                opacity: 0.7,
              }],
            },
          },
        },
        xaxis: {  
          //position: "bottom",
          tickLength: 0,
          //tickSize: [1, 'day'],
          //axisLabel: 'Provider',
          axisLabelUseCanvas: true,
          axisLabelFontSizePixels: 13,
          show:true,
          ticks: [
             [5, "Scheduled"], [10, "Gross Production"], [15, "Net Production"], [20, "Collection"]
          ]          
        },
        yaxis: {
          min: 0,
          axisLabel: 'Value',
          axisLabelUseCanvas: true,
          axisLabelFontSizePixels: 13,
          axisLabelPadding: 5,
        },
        grid: {
          hoverable: true,
          borderWidth: 0  
        },
        legend: {
          show: false,
          noColumns:  2,
          backgroundColor: 'transparent',
          labelBoxBorderColor: 'none',
          position:'sw',
          //container: 'div.legendContainer'
        },        
        colors: ['#a7beff', '#ace5d1', '#FFA45B','#ffc247'],
      };

      //let mergedOptions = {...defaultOptions, ...options};
      let mergedOptions = _.merge(defaultOptions, options);

      return $.plot($(this.$refs.chartContainer), dataSeries, mergedOptions);
    },
  },
  mounted() {
    // console.log(this.chartData);
    //console.log(`mounting chart`);
    this.createChart(this.chartData.data, this.chartData.options);
    // this.createChart(this.getDataSeries(this.getBarChartData()));
  },
};
</script>